import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.jsx";
import "./styles/theme.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false }
  }
});

createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={qc}>
    {/* basename '/dev' so routing works when served from /dev */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);
